import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import {
  MatTreeFlatDataSource,
  MatTreeFlattener
} from '@angular/material/tree';
import { SelectionModel } from '@angular/cdk/collections';
import { FlatTreeControl } from '@angular/cdk/tree';
import { AdminOrg } from 'src/app/models/admin-org.model';
import { AdminOrgNode } from 'src/app/models/admin-org-node.model';
import { environment } from 'src/environments/environment';
import { UserProfileService } from 'src/app/core/http/user-profile.service';
import { DataService } from 'src/app/services/data.service';

@Component({
    selector: 'app-user-region',
    templateUrl: './user-region.component.html',
    styleUrls: ['./user-region.component.scss'],
    standalone: false
})
export class UserRegionComponent implements OnInit, OnDestroy {
  orgData: any;
  newItemName = '';
  treeFlattener: any;
  checklistSelection: any;
  dataSource: any;
  adminOrgStucture: any;
  treeControl = new FlatTreeControl<AdminOrgNode>(
    (node) => node.level,
    (node) => node.expandable
  );
  private transformer = (node: AdminOrg, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      level,
      id: node.id ? node.id : 0
    };
  };

  getLevel = (node: AdminOrgNode) => node.level;

  isExpandable = (node: AdminOrgNode) => node.expandable;

  hasChild = (_: number, node: AdminOrgNode) => node.expandable;

  hasNoContent = (_: number, nodeData: AdminOrgNode) => nodeData.name === '';


  constructor(private ds: DataService, private userProfileService: UserProfileService,
    private ref: ChangeDetectorRef) {
    this.treeFlattener = new MatTreeFlattener(
      this.transformer,
      (node) => node.level,
      (node) => node.expandable,
      (node) => node.children
    );
    this.checklistSelection = new SelectionModel<AdminOrg>(true);
    this.dataSource = new MatTreeFlatDataSource(
      this.treeControl,
      this.treeFlattener
    );
    this.getUserorg();
  }

  descendantsAllSelected(node: AdminOrgNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected = descendants.every((child) =>
      this.checklistSelection.isSelected(child)
    );
    return descAllSelected;
  }

  /** Whether part of the descendants are selected */
  descendantsPartiallySelected(node: AdminOrgNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const result = descendants.some((child) =>
      this.checklistSelection.isSelected(child)
    );
    return result && !this.descendantsAllSelected(node);
  }

  /** Toggle the to-do item selection. Select/deselect all the descendants node */
  todoItemSelectionToggle(node: AdminOrgNode): void {
    this.checklistSelection.toggle(node);
    const descendants = this.treeControl.getDescendants(node);
    this.checklistSelection.isSelected(node)
      ? this.checklistSelection.select(...descendants)
      : this.checklistSelection.deselect(...descendants);

    // Force update for the parent
    descendants.every((child) => this.checklistSelection.isSelected(child));
    this.checkAllParentsSelection(node);
  }

  /** Toggle a leaf to-do item selection. Check all the parents to see if they changed */
  todoLeafItemSelectionToggle(node: AdminOrgNode): void {
    this.checklistSelection.toggle(node);
    this.checkAllParentsSelection(node);
  }

  /* Checks all the parents when a leaf node is selected/unselected */
  checkAllParentsSelection(node: AdminOrgNode): void {
    let parent: AdminOrgNode | null = this.getParentNode(node);
    while (parent) {
      this.checkRootNodeSelection(parent);
      parent = this.getParentNode(parent);
    }
  }

  /** Check root node checked state and change it accordingly */
  checkRootNodeSelection(node: AdminOrgNode): void {
    const nodeSelected = this.checklistSelection.isSelected(node);
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected = descendants.every((child) =>
      this.checklistSelection.isSelected(child)
    );
    if (nodeSelected && !descAllSelected) {
      this.checklistSelection.deselect(node);
    } else if (!nodeSelected && descAllSelected) {
      this.checklistSelection.select(node);
    }
  }

  /* Get the parent node of a node */
  getParentNode(node: AdminOrgNode): AdminOrgNode | null {
    const currentLevel = this.getLevel(node);

    if (currentLevel < 1) {
      return null;
    }

    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;

    for (let i = startIndex; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];

      if (this.getLevel(currentNode) < currentLevel) {
        return currentNode;
      }
    }
    return null;
  }
  getUserorg() {
    this.ds.getService(environment.BASEURL + '/GetOrgData')
      .subscribe(data => {
        if (this.userProfileService.getIsAdmin()) {
          let c = [];
          data.routes.forEach((x) => {
            x.imdms.forEach((y) => {
              y.tmEs.forEach((z) => { z.sectionManager.forEach((w) => { c.push(w.id)})});
            });
          });
          this.adminOrgStucture = c.toString();
        }
        const regex = /imdms|tmEs|sectionManager/gi;
        this.orgData = JSON.stringify(data.routes);
        this.orgData = this.orgData.replace(regex, 'children');
        this.dataSource.data = [];
        this.dataSource.data = JSON.parse(this.orgData);
        this.ref.detectChanges();
      });
  }

  ngOnInit() {
  }
  selectorgOnSelect(selectedOrg) {
    if (this.treeControl.dataNodes && selectedOrg) {
      const refreshedNodes = JSON.parse(JSON.stringify(this.dataSource.data));
      this.dataSource.data = [];
      this.dataSource.data = refreshedNodes;
      this.treeControl.dataNodes.map((node) => {
        if (node.id > 0 && selectedOrg.includes(node.id)) {
          this.todoItemSelectionToggle(node);
          let parent: AdminOrgNode | null = this.getParentNode(node);
          while (parent) {
            this.treeControl.expand(parent);
            parent = this.getParentNode(parent);
          }
        }
      });
    }
  }

  ngOnDestroy() { }
}

